import {lazy} from 'react';

export const WsdTableLazy = lazy(() => import(/* webpackChunkName: "wsdTable" */ '.'));
